<template>
    <div class="text-center">
        
        <v-progress-circular :rotate="360" :size="200" :width="24" :value="totalTrafficValue" color="#BDBDBD"
            class="mb-5">
            <h1 style="font-size: 2.5em; color: #616161;">{{ totalTrafficValue }}%</h1>
        </v-progress-circular>

        <v-col class="mb-3" v-if="!reference.rp_traffic">
            <v-btn  icon :color="trafficUnit === 'MB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changetrafficUnit('M')">
                MB
            </v-btn>
            <v-btn  icon :color="trafficUnit === 'GB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                class="ml-1 mr-1" @click="changetrafficUnit('G')">
                GB
            </v-btn>
            <v-btn  icon :color="trafficUnit === 'TB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changetrafficUnit('T')">
                TB
            </v-btn>
        </v-col>

        <div class="statistics_sub">
            <h5 class="ml-2"  style="color:#999;">{{ formattedDate }}</h5>
            <!-- <h5 v-if="this.startTime" class="mb-2" style="color:#999">{{ this.startTime }} ~ {{ this.endTime }}</h5> -->
            <!-- <span>{{ $store.getters.t('기준 사용량') }} {{ totalTraffic }} {{ trafficUnit }}</span> -->
            <span>{{ $store.getters.t('기준 사용량') }} {{ totalTrafficUnit }} {{ trafficUnit }}</span>
        </div>
        
        <h4>{{ $store.getters.t('사용') }} {{ usedTraffic }} <strong>{{ trafficUnit }}</strong></h4>
        <!-- <h4 v-if="usedTraffic">사용 {{ usedTraffic }} <strong>{{ trafficUnit }}</strong></h4>
        <h4 v-else class="statistics_sub"><span class="loading-icon mt-2 mr-2"></span></h4> -->
    </div>
</template>

<script>
import StatisticsApi from "@/api/statistics/StatisticsApi";

export default {
    name: 'TencentTrafficComponent',
    props: ['reference', 'units', 'formattedDate'],
    data() {
        return {
            OriginalTrafficUsage: 0,
            totalTrafficValue: '',
            usedTraffic: 0,
            startTime: '',
            endTime: '',
            totalTraffic: this.reference && this.reference.rp_traffic ? this.reference.rp_traffic : 1000,
            trafficUnit: this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'GB',
        };
    },
    // created() {
    //     this.trafficUnit = this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'GB';
        
    //     this.getTencentTrafficUsageData();
    // },
    methods: {
        async getTencentTrafficUsageData() {
            const [start, end] = this.formattedDate.split('~');
            const params = {
                startTime: start.trim(),
                endTime: end.trim()
            }
            const response = await StatisticsApi.tencentTrafficApi(params);
            // console.log("res => ", response)
            if(response){
                if(response.chartData){
                    if(response.chartData.TotalValue && !isNaN(parseFloat(response.chartData.TotalValue))) {
                        this.OriginalTrafficUsage = parseFloat(response.chartData.TotalValue).toFixed(2);
                        this.usedTraffic = this.OriginalTrafficUsage;

                        this.unitAutoChange();
                    } else {
                        this.usedTraffic = "0.00";
                        this.totalTrafficValue = 0;
                    }
                } else {
                    this.usedTraffic = "0.00";
                    this.totalTrafficValue = 0;
                } 
            }
            // const response = await StatisticsApi.tencentTrafficApi();
            // if (response.chartData && response.chartData.TotalValue && !isNaN(parseFloat(response.chartData.TotalValue))) {

            //     this.startTime = response.date.start_time;
            //     this.endTime = response.date.end_time;
  
            //     this.OriginalTrafficUsage = parseFloat(response.chartData.TotalValue).toFixed(2);
            //     this.usedTraffic = this.OriginalTrafficUsage;
             
            //     this.unitAutoChange();
            // } else {
            //     this.startTime = response.date.start_time;
            //     this.endTime = response.date.end_time;
            //     this.usedTraffic = "0.00";
            //     this.totalTrafficValue = 0;
            // }
        },
        calculatePercentage() {
            let baseTraffic = parseFloat(this.totalTraffic);
            let usedTraffic = parseFloat(this.usedTraffic);

            if(this.trafficUnit === 'MB'){
                baseTraffic = baseTraffic * 1000;
            } else if(this.trafficUnit === 'TB'){
                baseTraffic = baseTraffic / 1000;
            } else if(this.trafficUnit === 'GB'){
                baseTraffic = baseTraffic;
            }

            this.totalTrafficValue = ((usedTraffic / baseTraffic) * 100).toFixed(1);
        },
        unitAutoChange() {
            const usedTrafficInBytes = this.OriginalTrafficUsage;
            let usedTraffic = usedTrafficInBytes / (1000 * 1000);

            let unit = this.trafficUnit;

            if (this.reference && this.reference.rp_unit) {
                switch (this.reference.rp_unit) {
                    case 'TB':
                        usedTraffic /= (1000 * 1000);
                        break;
                    case 'GB':
                        usedTraffic /= 1000;
                        break;
                }
                this.trafficUnit = this.reference.rp_unit;
            } else {
                // if (usedTraffic > 1000 * 1000) {
                //     this.trafficUnit = 'TB';
                //     usedTraffic /= (1000 * 1000);
                // } else if (usedTraffic > 1000) {
                //     this.trafficUnit = 'GB';
                //     usedTraffic /= 1000;
                // } else {
                //     this.trafficUnit = 'MB';
                // }
                // switch (unit) {
                //     case 'MB':
                //         usedTraffic /= 1000 ** 2;
                //         break;
                //     case 'GB':
                //         usedTraffic /= 1000 ** 3;
                //         break;
                //     case 'TB':
                //         usedTraffic /= 1000 ** 4;
                //         break;
                // }
                // 기본값 -> MB
                switch (unit) {
                    case 'TB': 
                        usedTraffic /= 1024 ** 2;
                        break;
                    case 'GB': 
                        usedTraffic /= 1024;
                        break;
                    case 'MB': 
                        break;
                    case 'KB': 
                        usedTraffic *= 1024;
                        break;
                    case 'B': 
                        usedTraffic *= 1024 * 1024;
                        break;
                }

            }
            usedTraffic = Math.round(usedTraffic * 100) / 100;
            this.usedTraffic = usedTraffic.toFixed(2);
            this.calculatePercentage();
        },
        changetrafficUnit(units) {

            this.trafficUnit = units === 'M' ? 'MB' : units === 'G' ? 'GB' : 'TB';
            let usedMB = this.OriginalTrafficUsage / (1000 * 1000);
            switch (units) {
                case 'G': this.usedTraffic = (usedMB / 1000).toFixed(2); break;
                case 'T': this.usedTraffic = (usedMB / (1000 * 1000)).toFixed(2); break;
                default: this.usedTraffic = usedMB.toFixed(2);
            }
            this.calculatePercentage();
        },
        formatDate(date) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        },
    },
    watch: {
        'reference': {
            deep: true,
            immediate: true,
            handler(newVal) {
                //console.log("new", newVal);
                if (newVal && newVal.rp_unit) {
                    this.trafficUnit = newVal.rp_unit;
                } else {
                    this.trafficUnit = 'GB';
                }

                if (newVal && newVal.rp_traffic) {
                    this.totalTraffic = newVal.rp_traffic;
                } else {
                    this.totalTraffic = 1000;
                }
                this.getTencentTrafficUsageData();
                //this.unitAutoChange();
            }
        },
        'formattedDate' : {
            deep: true,
            immediate: true,
            handler(newVal) {
                // console.log("tencet traffic formattedData : ", newVal);
                
                this.usedTraffic = null;
                this.totalTrafficValue = null;
                this.getTencentTrafficUsageData();
            }
        },
    },
    computed: {
        totalTrafficUnit(){
            let val = 0;
            if(this.trafficUnit === 'MB'){
                val = this.totalTraffic * 1000;
            } else if(this.trafficUnit === 'TB'){
                val = this.totalTraffic / 1000;
            } else if(this.trafficUnit === 'GB'){
                val = this.totalTraffic;
            }
            return val;
        }
    }
};
</script>

<style>
.statistics_sub {
    color: #999;
    font-size: 14px;
}

h4 strong {
    color: #006cea;
}

.loading-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-top-color: #999;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


</style>